import { Directive, HostListener, Renderer2, ElementRef } from '@angular/core';

@Directive({
  selector: 'input[move-focus-on-number-input]',
})
export class MoveFocusOnNumberInputDirective {
  private numberKeys = Array.from(Array(10).keys()).map(String);

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  @HostListener('keyup', ['$event'])
  onKeyUp(e) {
    if (this.numberKeys.indexOf(e.key) > -1) {
      try {
        const currentId: number = +this.elementRef.nativeElement.id.slice(-1);
        if (currentId < 5) {
          const nextId: number = currentId + 1;
          const element = this.renderer.selectRootElement('#otpdigit' + nextId);
          element.focus();
          element.setSelectionRange(0, 1);
        }
      } catch {
        return;
      }
    }
  }

  @HostListener('click', ['$event'])
  onClick() {
    this.elementRef.nativeElement.focus();
    this.elementRef.nativeElement.setSelectionRange(0, 1);
  }
}
